import {UseState} from "../../../../../../react/use-state";
import {cs} from "../../../../../../react/chain-services";
import {consumeContext} from "../../../../../../react/context";
import * as React from "react";
import "./basic-input-live.scss";
import {cx} from "emotion";
import {filterControlTypes, filterEventTypes, trackFilterEvent} from "@common/utils/track-filter-event";

export const BasicInputLive = ({label, placeholder, disabled = false, className, state, hasError, onBlur, bind, list, style, trackingLabel}) =>
    cs(consumeContext("filterTrackingType"), ["focused", (_, next) => UseState({next})], ({focused, filterTrackingType}) => {
        const track = (eventType) =>
            trackFilterEvent({
                label: trackingLabel ?? label ?? placeholder,
                eventType,
                value: state?.value,
                type: filterTrackingType ?? filterControlTypes.input,
            });

        return (
            <div
                className={cx("basic-input-live-19z", className, {
                    focused: focused.value,
                    hasError,
                })}
            >
                <input
                    {...{
                        disabled,
                        list,
                        placeholder,
                        ...bind(state),
                        onFocus: () => {
                            track(filterEventTypes.focus);
                            focused.onChange(true);
                        },
                        onBlur: () => {
                            track(filterEventTypes.blur);
                            focused.onChange(false);
                            onBlur?.();
                        },
                        style,
                    }}
                />

                {label && (
                    <div
                        className={cx("label", {
                            up: focused.value || state.value != null,
                            focused: focused.value,
                        })}
                    >
                        {label}
                    </div>
                )}
            </div>
        );
    });
